export default __webpack_public_path__ + "static/media/mousai_desktop.c880f3d0.png";